<template>
  <div class="form-container w-100 h-100 d-flex">

    <div class="left-form-div">
      <div class="left-content h-100 mx-auto">
        <v-row cols="12" md="3" sm="6">
          <div class="d-flex site-logo">
            <img alt="logo" src="../../../../assets/svg/semfulllogo.svg" width=""/>
          </div>
        </v-row>
        <div class="form-holder d-flex justify-content-center align-items-center">
          <div class="form w-100">
            <v-row cols="12" md="3" sm="6">
              <h3 class="form-title ml-1">Welcome back</h3>

            </v-row>
            <ValidationObserver v-slot="{ handleSubmit }">
              <v-form v-if="!submitted" @submit.prevent="handleSubmit(LoginFromSubmitButton)">
                <Loader :loading="loading" :message="message"/>
                <div v-if="serverResponse" class="red--text mb-2 mt-2">
                  {{ serverResponse }}
                </div>
                <ValidationProvider v-slot="{errors}" name="Email" rules="required|email">
                  <span class="err">{{ errors[0] }}</span>
                  <v-row cols="12" md="3" sm="6">
                    <v-text-field v-model="user.email"
                                  color="secondary"
                                  label="Email Address "
                                  name="email"
                                  outlined
                                  type="email">
                      // autoComplete={}

                    </v-text-field>
                  </v-row>
                </ValidationProvider>
                <ValidationProvider v-slot="{errors}" name="Password" rules="required">
                  <span class="err">{{ errors[0] }}</span>
                  <v-row cols="12" md="3" sm="6">
                    <v-text-field v-model="user.password"
                                  label="Password"
                                  onautocomplete="on"
                                  outlined
                                  type="password">
                    </v-text-field>
                  </v-row>
                </ValidationProvider>
                <br/>

                <p id="passwordErr" class="text-danger"></p>
                <button class="d-block w-100 p-3 my-3 bt" type="submit">Log In</button>
              </v-form>

              <p id="err" class="text-danger"></p>

              <!--                                <a href="/resetPassword/" class=" forget terms">  <p > Forgot your password?</p></a>-->

            </ValidationObserver>

          </div>

        </div>
      </div>
    </div>
    <div class="right-ill-div h-100 login-right">
      <div class="form-img d-flex justify-content-center align-items-center h-100">
        <img alt="doorIll" src="../../../../assets/svg/desk-illu.svg" width="500px"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {APPLICANT_DASHBOARD, loginUser} from "../../../../services/ApiServices";
import Loader from "../ElderDashboard/ElderDashboardBody/Loader";

export default {
  name: "LoginPage",
  components: {Loader},
  data() {
    return {
      user: {
        email: "",
        password: ""
      },
      loading: false,
      message: "Please wait",
      submitted: false,
      serverResponse: ''

    }
  },
  beforeCreate() {
    // this.LoginElder(this.props.match.params.userToken)
    this.LoginUser(this.$route.params.userToken);
  },

  created() {
    this.LoginUser(this.$route.params.userToken);
    // this.LoginElder(this.props.match.params.userToken)
  },


  methods: {

    Redirect(token) {
      window.location.href = APPLICANT_DASHBOARD + '/redirect/' + token;
    },
    LoginFromSubmitButton() {
      this.loading = true
      axios.post(loginUser, {
        email: this.user.email,
        password: this.user.password,
      }).then(response => {
        this.LoginUser(response.data.accessToken)
      })
          .catch(err => {
            console.log(err.response.data)
            if (err.response === undefined) {
              this.serverResponse = "Check your internet connection and try again"
            } else {
              this.serverResponse = err.response.data.message;
            }
            this.loading = false
          })
    },

    LoginUser(userToken) {
      const jwtDecode = require('jwt-decode')
      const decodedUserToken = jwtDecode(userToken)
      const userRole = decodedUserToken.roles;
      switch (userRole) {
        case 'SPONSOR':
        case 'ELDER': {
          const elder = decodedUserToken.userData.firstName;
          const headers = {
            ContentType: "application/json",
            Authorization: `Bearer ${userToken}`,
          }
          sessionStorage.setItem('userRole', JSON.stringify(userRole));
          sessionStorage.setItem('userBatchId', JSON.stringify(decodedUserToken.userData.batchId))
          sessionStorage.setItem('elderName', JSON.stringify(elder))
          sessionStorage.setItem('headers', JSON.stringify(headers));
          this.$router.push('/dashboard');
          break;
        }
        case 'ADMIN': {
          this.Redirect(userToken);
          break;
        }
        case 'APPLICANT': {
          this.Redirect(userToken);
          break;
        }
        case 'NATIVE': {
          this.Redirect(userToken);
          break;
        }
        default: {
          this.loading = false;
          this.serverResponse = 'Unauthorized';
        }
      }


    }
  }
}
</script>

<style scoped>
@import "../../../../css/login.css";

span {
  color: red !important;
}

</style>


